<template lang="pug">
.file-uploader-single
  FileTile.file(v-if="file" :file="file" removable @remove="$emit('change', null)")
  FileTile.file(
    v-else-if="uploadingFile"
    :file="uploadingFile.file"
    :process="uploadingFile.process"
    :progress="uploadingFile.progress"
    removable
    @remove="stopUploading"
  )
  template(v-else)
    Icon(name="folders")
    .title(v-if="title") {{ title }}
    Btn(label xs)._btn Выбрать файл
      input._input(type="file" hidden @change="uploadFile")
</template>

<script>
import FileTile from '@/components/FileTile.vue';
import { v4 as uuidv4 } from 'uuid';
import fileApi from '@/api/file';


export default {
  name: 'FileUploaderSingle',
  components: { FileTile },
  props: {
    file: [Object, File],
    title: String,
  },
  data() {
    return {
      uploadingFile: null,
    };
  },
  methods: {
    async uploadFile(event) {
      const file = event.target.files[0];
      this.uploadingFile = {
        file,
        error: '',
        '@id': uuidv4(),
        progress: 0,
        process: 'waiting',
        removable: true,
        controller: new AbortController(),
      };

      if (this.uploadingFile.file.size > 2147483647) {
        this.uploadingFile.error = 'Максимальный размер файла 2ГБ'; // eslint-disable-line no-param-reassign
        this.uploadingFile.process = null; // eslint-disable-line no-param-reassign
        return;
      }

      const progressCallback = (progress) => {
        this.uploadingFile.progress = progress;                                // eslint-disable-line
        this.uploadingFile.process = progress > 0 ? 'uploading' : 'waiting';   // eslint-disable-line
      };

      this.uploadingFile.progress = 0.5;
      this.uploadingFile.process = 'uploading';

      try {
        const createdFile = await fileApi.create(this.uploadingFile.file, progressCallback, this.uploadingFile.controller);
        // this.uploadingFile.removable = false; // eslint-disable-line no-param-reassign
        this.$emit('change', createdFile.data);
        this.uploadingFile = null;
      } catch (err) {
        console.log(err);
        this.uploadingFile.process = null; // eslint-disable-line
        this.uploadingFile.error = 'Ошибка загрузки'; // eslint-disable-line
      }
    },
    stopUploading() {
      this.uploadingFile.controller.abort();
      this.uploadingFile = null;
    },
  },
};
</script>

<style scoped lang="scss">
  .file-uploader-single {
    border: 1px dashed var(--color-violent-gray);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    padding: 33px 0;
    gap: 13px;

    svg {

    }
  }

  .file {
    width: 82px;
  }

  .title {
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #99A3C5;
  }

  .container {
    border: 1px dashed var(--color-violent-gray);
    background: #F8F9FC;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 33px 0;
  }
</style>
